import React from "react";
import { motion } from "framer-motion";
import { XCircleIcon } from "lucide-react";
const pains = ['"¿Sonaré profesional o el cliente pensará que soy un aficionado?"', '"¿Se darán cuenta de que uso el traductor de Google?"', "Contratos de $5.000 perdidos por un email mal escrito.", "ChatGPT te da traducciones robóticas que los clientes ignoran.", "Compites por clientes que piden rebajas y te pagan en pesos."];
export function PainSection() {
  return <section className="w-full bg-[#0a0a1f] py-16" data-id="element-155" data-mp="2pz2jtm4i73tq">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-156" data-mp="2q0ncf679ccoy">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-157" data-mp="2baogzb737fd6">
          Ese "miedo" ya te costó{" "}
          <span className="text-red-400" data-id="element-158" data-mp="2ga0zjjqxe09y">miles de dólares</span> este año
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-slate-300" data-id="element-159" data-mp="22ajad39pwl02">
          Cada vez que intentas escribir un email, enviar una propuesta en
          LinkedIn o tener una llamada, te invade la misma duda:
        </p>

        <div className="mt-8 space-y-3" data-id="element-160" data-mp="3rl7lu15sk1x2">
          {pains.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-3 rounded-xl border border-red-500/15 bg-red-500/5 px-4 py-3" data-id="element-161" data-mp="3nknooxl7wyax" data-mpi={i}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" data-id="element-162" data-mp="33xpxygpndnzd" />
              <p className="text-slate-200" data-id="element-163" data-mp="33vlnffx8tqq4">{p}</p>
            </motion.div>)}
        </div>

        <p className="mt-8 text-center font-display text-xl font-bold text-white sm:text-2xl" data-id="element-164" data-mp="3io5kpzxpp3zn">
          Tengo una noticia para ti:{" "}
          <span className="text-emerald-400" data-id="element-165" data-mp="2q59whkce9y0k">la barrera del idioma ha muerto.</span>
        </p>
      </div>
    </section>;
}